import { useFormContext } from 'react-hook-form';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import type { ConsultantHourPackageForm } from '@/schemas/consultant-hour-package';

/**
 * The editable consultant hour package fields (name, hours, sort order), shared by the add and
 * edit dialogs. Must be rendered inside a react-hook-form FormProvider whose form includes these
 * fields.
 */
export function ConsultantHourPackageFields() {
  const {
    register,
    formState: { errors },
  } = useFormContext<ConsultantHourPackageForm>();

  return (
    <>
      <div className="grid gap-2">
        <Label htmlFor="packageDisplayName">Name</Label>
        <Input
          id="packageDisplayName"
          type="text"
          maxLength={200}
          placeholder="5 Wrangler Hours"
          {...register('displayName')}
        />
        {errors.displayName && (
          <p className="text-sm text-destructive">{errors.displayName.message}</p>
        )}
      </div>
      <div className="grid gap-4 sm:grid-cols-2">
        <div className="grid gap-2">
          <Label htmlFor="packageHours">Hours per purchase</Label>
          <Input
            id="packageHours"
            type="number"
            step="0.01"
            min="0.01"
            {...register('hours', { valueAsNumber: true })}
          />
          {errors.hours && <p className="text-sm text-destructive">{errors.hours.message}</p>}
        </div>
        <div className="grid gap-2">
          <Label htmlFor="packageSortOrder">Sort order</Label>
          <Input
            id="packageSortOrder"
            type="number"
            step="1"
            {...register('sortOrder', { valueAsNumber: true })}
          />
          {errors.sortOrder && (
            <p className="text-sm text-destructive">{errors.sortOrder.message}</p>
          )}
        </div>
      </div>
    </>
  );
}
